import { cn } from '@/lib/utils';
import type { LinkStatus } from '@/types/api';

interface StatusBadgeProps {
  status: LinkStatus;
  className?: string;
}

const statusConfig: Record<LinkStatus, { label: string; className: string }> = {
  active: {
    label: '有効',
    className: 'bg-green-100 text-green-800',
  },
  paused: {
    label: '一時停止',
    className: 'bg-yellow-100 text-yellow-800',
  },
  expired: {
    label: '期限切れ',
    className: 'bg-red-100 text-red-800',
  },
};

export function StatusBadge({
  status,
  className,
}: StatusBadgeProps): React.ReactElement {
  const config = statusConfig[status];

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-1 text-xs font-medium',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
}
